
<template>
  <span
    v-if="hint"
    class="text--red"
  >{{hint}}</span>
</template>

<script>
export default {
  props: {
    error: { type: Object, required: true },
    name: { type: String, required: true }
  },
  computed: {
    hint: function () {
      return (this.error && this.name && this.error.fieldId === this.name) ? this.error.errorMessage : ''
    }
  }
}
</script>
